export const CssVariablesTheme = {
    // Header
    headerColor: '#8b959e',
    headerBackground: '#ffffff',
    headerApplyBtnBg: 'transparent',
    headerApplyBtnBorderColor: '#39F179',
    headerApplyBtnColor: '#000000',
    headerFontSize: '16px',
    headerActiveLinkColor: '#000000',
    logoMaxSize: '100%',

    /* Body*/
    formTextColor: '',
    background: '#ffffff',
    font: 'SF Pro Text',
    fontSize: '16px',
    itemListBg: '#f6f7f8',
    basePageWidth: '',
    basePageMaxWidth: '',

    /* Form*/
    labelColor: '#828B94',
    inputBorderColor: '#DADEE2',
    inputBg: '#ffffff',
    inputBorderColorHover: '#39F179',
    inputBorderRadius: '8px',
    formButtonsBg: '#39F179',
    formButtonsColor: '#000000',
    tabsColor: '#a9afb7',
    calculatorSecondaryText: '#A9AFB7',
    calculatorSliderTrack: '#39F179',
    calculatorInputColor: '#000000',
    calculatorSliderHandleBg: '#39F179',
    calculatorSliderHandleBorder: '#39F179',
    tabsBorderBottomColor: 'transparent',
    activeTabColor: '#39F179',
    activeTabBorderColor: '#39F179',

    /* Footer*/
    footerBg: '#ffffff',
    footerTextColor: '#97a8b8',

    /* Statuses color */
    pending: {
        color: '#000000',
        borderColor: '#9B9BA4',
        backgroundColor: '#9B9BA4',
    },
    active: {
        color: '#000000',
        borderColor: '#3FE579',
        backgroundColor: '#3FE579',
    },
    repaid: {
        color: '#000000',
        borderColor: '#9B9BA4',
        backgroundColor: '#9B9BA4',
    },
    overdue: {
        color: '#000000',
        borderColor: '#F33F4A',
        backgroundColor: '#F33F4A',
    },
    writtenOff: {
        color: '#000000',
        borderColor: '#d6d6d6',
        backgroundColor: '#d6d6d6',
    },
    processing: {
        color: '#000000',
        borderColor: '#E3DB40',
        backgroundColor: '#E3DB40',
    },
    error: {
        color: '#000000',
        borderColor: '#F33F4A',
        backgroundColor: '#F33F4A',
    },
    onKyc: {
        color: '#000000',
        borderColor: '$9B9BA4',
        backgroundColor: '#9B9BA4',
    },
    verification: {
        color: '#000000',
        borderColor: '#9B9BA4',
        backgroundColor: '#9B9BA4',
    },
    updateRequested: {
        color: '#000000',
        borderColor: '#9B9BA4',
        backgroundColor: '#9B9BA4',
    },
    underwriting: {
        color: '#000000',
        borderColor: '#9B9BA4',
        backgroundColor: '#9B9BA4',
    },
    declined: {
        color: '#000000',
        borderColor: '#F33F4A',
        backgroundColor: '#F33F4A',
    },
    canceled: {
        color: '#000000',
        borderColor: '#F33F4A',
        backgroundColor: '#F33F4A',
    },
    approved: {
        color: '#000000',
        borderColor: '#3FE579',
        backgroundColor: '#3FE579',
    },
    disbursed: {
        color: '#000000',
        borderColor: '#3FE579',
        backgroundColor: '#3FE579',
    },
    forReview: {
        color: '#797064',
        borderColor: '#F5F6F7',
        backgroundColor: '#F5F6F7',
    },
    underReview: {
        color: '#797064',
        borderColor: '#F5F6F7',
        backgroundColor: '#F5F6F7',
    },
    requestsApproved: {
        color: '#151813',
        borderColor: '#F4F0DF',
        backgroundColor: '#F4F0DF',
    },
    requestsDeclined: {
        color: '#fa656c',
        borderColor: '#FFE4E4',
        backgroundColor: '#FFE4E4',
    },
    requestsSigning: {
        color: '#797064',
        borderColor: '#F5F6F7',
        backgroundColor: '#F5F6F7',
    },
    requestsApplied: {
        color: '#151813',
        borderColor: '#F4F0DF',
        backgroundColor: '#F4F0DF',
    },

    isFilledStatus: false,
};
